module.exports = __webpack_public_path__ + "img/map_icon.84becdf7.svg";